import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="protected-loading">
        <div className="h-10 w-10 rounded-full border-2 border-slate-200 border-t-[#002FA7] animate-spin"></div>
      </div>
    );
  }
  // Fallback: if user was passed via route state from AuthCallback (Google OAuth race
  // where setUser may commit on the next tick), trust it for this render.
  if (!user && !location.state?.user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return children;
}
